import CartRepository from "../../repository/CartRepository";

class Common {
    getCartProductInventoryQuantityByERPPartNumber = (ERPPartNumber, CART_PRODUCT_INVENTORY_DATA) => {
        return new CartRepository().getInventoryQuantity(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    };
    getCartProductInventoryObjectByERPPartNumber = (ERPPartNumber, CART_PRODUCT_INVENTORY_DATA) => {
        return new CartRepository().getInventoryObject(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    };
    getCartProductPricingByERPPartNumber = (ERPPartNumber, CART_PRODUCT_PRICING_DATA) => {
        return new CartRepository().getPricing(ERPPartNumber, CART_PRODUCT_PRICING_DATA);
    };
    getInventoryOutOfStockFlag = (CART_DATA, CART_PRODUCT_DATA = false, skip_obsolete_check = true) => {
        let d = false;
        if (CART_DATA !== undefined && CART_DATA &&
            CART_DATA.length > 0
        ) {
            let isBroken = false;
            CART_DATA.map((res) => {
                if (isBroken) {
                    return;
                }
                let check = true;
                if (skip_obsolete_check === false &&
                    CART_PRODUCT_DATA && CART_PRODUCT_DATA[res.ERPPartNumber] !== undefined &&
                    CART_PRODUCT_DATA[res.ERPPartNumber].ObsoleteFlag === true
                ) {
                    check = false;
                }
                if (check) {
                    let a_q = new CartRepository().getUnadjustedQuantity(res.ERPPartNumber);
                    if (res.isEligibleShipping !== false && a_q > 0) {
                        d = true;
                        isBroken = true;
                        return;
                    }
                }
            })
        }
        return d;
    };
    getInventoryOutOfStockFlagByERPPartNumber = (CART_DATA_OBJECT, ERPPartNumberSingleOnly, takePropertiesFromCart = true, quantity = 0, inventory_quantity = 0, back_order_quantity = 0) => {
        let d = false;
        let a_q = new CartRepository().getUnadjustedQuantity(
            ERPPartNumberSingleOnly,
            takePropertiesFromCart, quantity, inventory_quantity, back_order_quantity
        );
        if (takePropertiesFromCart === false && a_q > 0) {
            d = true;
        }
        if (takePropertiesFromCart === true && CART_DATA_OBJECT &&
            CART_DATA_OBJECT[ERPPartNumberSingleOnly] !== undefined &&
            CART_DATA_OBJECT[ERPPartNumberSingleOnly].isEligibleShipping !== false && a_q > 0) {
            d = true;
        }
        return d;
    };

    getCartProductInventoryLeadTimeByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA) {
        return new CartRepository().getInventoryLeadTime(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    }

    checkVendorExcluded(CART_DATA)
    {
        let d = false;
        if (CART_DATA && CART_DATA.length > 0 &&
            CART_DATA.filter(x=>x?.isVendorExcluded === true).length > 0) 
        {
            d = true;
        }
        return d;
    }
}

export default Common;